import React, { useEffect, useState } from 'react';
import TipificacionFlow from './TipificacionFlow';
import apiInstance from '../../../services/ServiceApi';

const Tipificacion = () => {
  const [tipificacionesData, setTipificacionesData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiInstance.get('tipificacionesAdmin/?linea_negocio=1'); // Reemplaza 'ruta-de-tu-api' por la ruta real de tu API
        setTipificacionesData(response.data);
      } catch (error) {
        console.error('Error al obtener datos de la API:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="parent-component">
      <h2>Flujo de Tipificaciones</h2>
      <TipificacionFlow data={tipificacionesData} />
    </div>
  );
};

export default Tipificacion;
